import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Toolbar from '@mui/material/Toolbar';
import classNames from 'classnames';
import { ReactComponent as CircleLogo } from '@/assets/images/instil-circle-logo.svg';
import EditProfileModal from '@/components/editProfile/EditProfileModal';
import UserProfile from '@/components/layout/UserProfile';
import useCurrentUser from '@/lib/hooks/useCurrentUser';
import translate from '@/lib/intl/translate';
import { LayoutContext } from './LayoutProvider';
import NavigationHeader from './NavigationHeader';
import NavigationList from './NavigationList';
import useCompanyNavListItem from './useCompanyNavListItem';

function MobileNavigation() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const { setIsExpanded } = React.useContext(LayoutContext);
  const location = useLocation();
  const { orgName } = useCompanyNavListItem();
  const { isSuperAdmin } = useCurrentUser();

  const appBarRef = useRef();

  const handleMenu = () => {
    setIsExpanded(true);
    setAnchorEl(appBarRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    handleClose();
  }, [location]);

  return (
    <div
      className={classNames(
        'sticky z-30 flex h-16 w-full flex-col overflow-y-hidden bg-transparent hide-scrollbar [grid-area:menu] sm:h-20',
        {
          'top-12 sm:top-14': isSuperAdmin,
          'top-0': !isSuperAdmin,
        },
      )}
      ref={appBarRef}
    >
      <AppBar color="inherit" position="static">
        <Toolbar>
          <IconButton
            data-testid="mobile-navigation-menu-button"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleMenu}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <CircleLogo
            aria-label={translate('ICON_INSTIL_LOGO_ICON')}
            className="h-8 w-8"
          />
          <Divider
            className="ml-2 mr-1 h-4 border-text-disabled"
            orientation="vertical"
          />
          <span className="truncate type-h4">{orgName}</span>
          <SwipeableDrawer
            classes={{
              paper: 'bg-grey-100 flex flex-col justify-between h-full rounded',
            }}
            container={appBarRef.current}
            id="menu-appbar"
            onOpen={() => {}}
            onClose={handleClose}
            open={Boolean(anchorEl)}
            ModalProps={{ BackdropProps: { invisible: true } }}
          >
            <div className="flex h-full flex-col">
              <div className="basis-20">
                <NavigationHeader />
              </div>
              <div className="flex-auto">
                <NavigationList />
              </div>
              <Divider />
              <UserProfile />
            </div>
          </SwipeableDrawer>
        </Toolbar>
      </AppBar>
      <EditProfileModal
        open={isEditModalOpen}
        handleClose={() => setEditModalOpen(false)}
      />
    </div>
  );
}

export default MobileNavigation;
